import {Component, OnDestroy, OnInit} from '@angular/core';
import {User} from "../../../shared/interface/user";
import {ReplaySubject} from "rxjs";
import {ActivatedRoute} from "@angular/router";
import {UserService} from "../../../shared/services/user.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {DictService, PERMISSIONS_TYPE} from "../../../shared/services/dict.service";
import {FormBuilder} from "@angular/forms";
import {AuthService} from "../../../shared/services/auth.service";
import {RegionalService} from "../../../shared/services/regional.service";
import {PermissionTagsService} from "../../../shared/services/permission-tags.service";
import {InsuranceCompanyService} from "../../../shared/services/insurance-company.service";
import {takeUntil} from "rxjs/operators";
import {Dictionary} from "../../../shared/interface/dictionary";
import {HttpErrorResponse} from "@angular/common/http";
import {MatTabChangeEvent} from "@angular/material/tabs";

@Component({
  selector: 'app-user-licenses-details',
  templateUrl: './user-licenses-details.component.html',
  styleUrls: ['./user-licenses-details.component.scss']
})
export class UserLicensesDetailsComponent implements OnInit, OnDestroy {

  userId: string;
  userObject?: User;
  user: ReplaySubject<User> = new ReplaySubject<User>(1);
  modify = false;


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private snack: MatSnackBar,
    private dictService: DictService,
    private fb: FormBuilder,
    private auth: AuthService,
  ) { }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.userId = params.id;
        this.loadUser();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadUser(): void {
    this.userService.get(this.userId).subscribe((user: User) => {
      this.user.next(user);
      this.userObject = user;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych użytkownika', error.status.toString(), {
        duration: 2000
      });
    });
  }

  onTabChange(e: MatTabChangeEvent): void {
  }

}
